import PaymentMethodsContainer from "./PaymentMethodsContainer";
import PaymentProccessComponent from "./PaymentProccessComponent";
import { Box, useToast } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import useApiRequest from "hooks/api/useApiHook";
import { useSelector } from "react-redux";
import { RootState } from "redux/store";
import { RequestMethod, RequestName } from "hooks/api/apiHookTypes";
import { useTopUpBalanceContext } from "context/TopUpBalanceContext";
import "./BalanceTopUp.css";
import { useNavigate } from "react-router-dom";

const BalanceTopUp = () => {
  const apiToken = useSelector((state: RootState) => state.apiKey.apiKey);

  const invoiceParams = {
    apiToken: apiToken,
    method: RequestMethod.GET,
    name: RequestName.CREATE_INVOICE,
    createInvoiceParams: {
      currency: null,
      network: null,
      amount: null,
    },
  };

  const [requestParams, setRequestParams] = useState(invoiceParams);

  const { currency, network, amount, setAmount, setCurrency, setNetwork } =
    useTopUpBalanceContext();

  const { data, error, loading } = useApiRequest(requestParams);

  const navigate = useNavigate();
  const toast = useToast();

  const createInvoice = () => {
    const invoiceParams = {
      apiToken: apiToken,
      method: RequestMethod.GET,
      name: RequestName.CREATE_INVOICE,
      createInvoiceParams: {
        currency: currency,
        network: network,
        amount: amount,
      },
    };
    setRequestParams(invoiceParams);
  };

  useEffect(() => {
    if (data?.status === "success") {
      navigate(`/invoice/${data.data.invoice_id}`);
    } else if ((data?.status === "error" || error) && currency) {
      // Backend returns error_response ({status:"error"}) with HTTP 200 on
      // gateway failures, so a business error never populates `error`. Surface
      // it here too, otherwise the button silently does nothing.
      toast({
        title: "Something went wrong.",
        description: data?.message || "Try another network or try later.",
        status: "error",
        position: "top",
        duration: 9000,
        isClosable: true,
      });
    }
    //eslint-disable-next-line
  }, [data, error, loading, navigate]);

  return (
    <Box className="balance-top-up">
      <PaymentMethodsContainer
        setCurrency={setCurrency}
        setNetwork={setNetwork}
      />
      <Box className="payment-process-container">
        <PaymentProccessComponent
          amount={amount}
          network={network}
          currency={currency}
          setAmount={setAmount}
          createInvoice={createInvoice}
        />
      </Box>
    </Box>
  );
};

export default BalanceTopUp;